import React from 'react';
import { cn } from '@/lib/utils';
import { ShoppingCart } from 'lucide-react';
export function CTAButton({
  className = ''
}: {
  className?: string;
}) {
  return <a href="https://checkout.ebookbtnlines.shop/cart/45562585514031:1" className={cn(`inline-flex items-center justify-center gap-2 bg-forest hover:bg-forest-light text-white font-display font-bold text-lg md:text-xl py-4 px-8 rounded-full shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 w-full md:w-auto text-center ${className}`, 'text-[14px] font-[Poppins,_sans-serif]')} data-id="element-46">
      <ShoppingCart className="w-6 h-6" data-id="element-47" />
      QUIERO ENTRENAR MI MENTE
    </a>;
}